import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.conversion.checkout.containers.CheckoutDeliveryTime.modalTitle',
    defaultMessage: 'Ya no hay horarios de entrega disponibles',
  },
  subtitle: {
    id: 'app.conversion.checkout.containers.CheckoutDeliveryTime.modalSubTitle',
    defaultMessage:
      'Lamentablemente ya no hay más horarios de entrega disponibles para éste mercado.',
  },
  button: {
    id: 'app.conversion.checkout.containers.CheckoutDeliveryTime.modalButton',
    defaultMessage: 'Ver otros mercados',
  },
});
